// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__uNNMA","loading":"Loading_loading__VAvnG","spinner":"Loading_spinner__NsLLq"};